var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27604",
    "data-name": "Path 27604",
    d: "M4.876,145.622,4.11,148.48l-2.8.059a11.019,11.019,0,0,1-.081-10.272h0l2.492.457L4.814,141.2a6.565,6.565,0,0,0,.062,4.42Z",
    transform: "translate(0 -132.327)",
    fill: "#fbbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27605",
    "data-name": "Path 27605",
    d: "M272.194,208.176a11,11,0,0,1-3.921,10.633h0l-3.139-.16-.444-2.773a6.556,6.556,0,0,0,2.821-3.348h-5.882v-4.352h10.566Z",
    transform: "translate(-250.386 -199.231)",
    fill: "#518ef8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27606",
    "data-name": "Path 27606",
    d: "M47.084,315.692h0a11,11,0,0,1-16.576-3.365l3.565-2.918a6.542,6.542,0,0,0,9.427,3.35Z",
    transform: "translate(-29.198 -296.114)",
    fill: "#28b446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27607",
    "data-name": "Path 27607",
    d: "M45.415,2.532,41.852,5.45a6.541,6.541,0,0,0-9.644,3.425L28.625,5.941h0A11,11,0,0,1,45.415,2.532Z",
    transform: "translate(-27.394)",
    fill: "#f14336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.07c2532f050a8e7e00fcd515883b4942.svg";
export { ForwardRef as ReactComponent };